import { render, staticRenderFns } from "./main-feature.vue?vue&type=template&id=1e79f92b&scoped=true&"
import script from "./main-feature.vue?vue&type=script&lang=js&"
export * from "./main-feature.vue?vue&type=script&lang=js&"
import style0 from "./main-feature.vue?vue&type=style&index=0&id=1e79f92b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e79f92b",
  null
  
)

export default component.exports